import React, { FC } from "react";

export interface SuccessPageContentProps {
  heading: string;
  text: string;
}

export const SuccessPageContent: FC<SuccessPageContentProps> = ({
  heading,
  text,
}) => (
  <div className="hero-image hero-image-city">
    <div className="l-wrapper clearfix">
      <div className="l-8-cols-tablet">
        <h1 className="color-primary">{heading}</h1>
        <p className="text-1">{text}</p>
        <div className="l-push-top">
          <a className="button button-ghost-primary" href="/">
            GO TO HOMEPAGE
          </a>
        </div>
      </div>
    </div>
  </div>
);
